/** Public app listings shared by web badges and transactional email links. */
export const APP_STORE_URL = "https://apps.apple.com/us/app/bookaclassic/id6777553914";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=bookaclassic.driveshare.com";